import { render, staticRenderFns } from "./Injection.vue?vue&type=template&id=33463b7a&"
import script from "./Injection.vue?vue&type=script&lang=ts&"
export * from "./Injection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports